import { data } from "jquery";
import { postRequest } from "../../config/AxiosConfig"
import API_URLS from "../../config/BackendConfig"
import { getAuthToken } from "../../utils/tokenUtils";

export const AddIpService = async ( payload ) => {
    try {
        
        const body = {
            'user_id': payload.user_id,
            'ip_address': payload.ip_address,
        }

        const token = getAuthToken();

        const respone = await postRequest({
            url: API_URLS.ADMIN + 'ip/add',
            headers: {
                'Authorization': `Bearer ${token}`
            },

            data: body,
        });
        return respone
    } catch (error) {
        return error;
    }
}